@if (!selectExistingBook) {
  <app-new-book (bookCreated)="selectBook($event)"></app-new-book>
}
@if (selectExistingBook) {
  <div class="dropdown-select" (click)="showBookShelf = !showBookShelf">
    Select <span class="icon-arrow-down float-right"></span>
  </div>
}
@if (author) {
  <div class="flex" (click)="toggleBookSource()">
    <button class="btn light sm">{{ subActionText }}</button>
  </div>
}

@if (showBookShelf) {
  <div class="book-list">
    <div >
      <div class="search">
        <app-input-form
          [form]="form"
          [id]="bookId"
          [required]="true"
          (keyup)="searchBooks()"
        ></app-input-form>
      </div>
      @if (loading) {
        <div class="loading-container">
          <app-spinner></app-spinner>
        </div>
      } @else {
        <ul>
          @for (book of filteredBooks; track book) {
            <li (click)="selectBook(book)">
              <div class="image">
                <img src="{{book.amazonImageUrl || defaultImageUrl}}" alt="{{book.title}}" />
              </div>
              <h4 class="title strong2">{{book.title}}</h4>
              <div class="author">by {{book.author}}</div>
            </li>
          }
        </ul>
      }
    </div>
  </div>
}
